import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles, Fab, Modal, Button, IconButton } from "@material-ui/core";
import stylesPc from "./EditSlideStock.module.css";
import stylesSp from "./EditSlideStock_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";
import { Group } from "../../../../user/User";
import { isAdmin, isEditor } from "../../../../utils/LogicUtils";
import SlideStockInfoDetail from "../../../../admin/viewer/slideStocks/SlideStockInfoDetail";
import { DetailInfo } from "../../../../admin/viewer/slideStocks/DetailInfo";
import { Chapter, Tip } from "../../../../models/slides";
import OnLeaveDialog from "../../../../common/components/dialog/OnLeaveDialog";
import {
    DeleteTempFile,
    EditSlide,
    GetSlideById,
    GetSlidePageCount,
    GetTempPageCount,
    ResetSlideInfo,
    DeleteSlide,
} from "../../../../store/actions/SlideActions";
import EditIcon from "@material-ui/icons/Edit";
import { GetUserInfoList } from "../../../../user/UserActions";
import { useInitFlag } from "../../../../components/function/useInitFlag";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import { useHistory, useLocation } from "react-router-dom";
import { VideoExtraMaterial } from "../../../../common/video/models/VideoExtraMaterial";
import { GetTagIdFromTagName } from "../../../../utils/ObjectUtils";
import { getTagList } from "../../../../common/video/VideoActions";
import PuiTypography from "../../../../components/elements/PuiTypography";
import ClearIcon from "@material-ui/icons/Clear";

interface EditSlideStockProps {
    slideId: number;
    setIsEditing?: (target: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)",
            },
        },
    })
);

function EditSlideStock({ slideId, setIsEditing }: EditSlideStockProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    // データ取得
    const {
        user,
        slide,
        slidePageCount,
        tempFile,
        tempFilePageCount,
        isSuccessGetTempFilePageCount,
        isSuccessDeleteSlide,
        tags,
    } = useSelector((state: AppState) => ({
        user: state.user.user,
        slide: state.slide.slide,
        slidePageCount: state.slide.slidePageCount,
        tempFile: state.slide.tempFile,
        tempFilePageCount: state.slide.tempFilePageCount,
        isSuccessGetTempFilePageCount: state.slide.isSuccessGetTempFilePageCount,
        isSuccessDeleteSlide: state.slide.isSuccessDeleteSlide,
        tags: state.video.tags,
    }));

    // コンテンツ情報表示か、スライド・チャプター・補足情報表示かのた、変数定義
    const [visibleDetailInfoPage, ShowDetailInfoPage] = useState(true);

    //【詳細情報入力】ボタン押下
    const handleDetailInfoBtn = () => {
        ShowDetailInfoPage(false);
    };

    // 完了ボタン押下
    const handleCompleteBtn = () => {
        ShowDetailInfoPage(true);
    };

    // ユーザ入力保存確認
    const [isSaved, setIsSaved] = useState(true);

    // コンテンツアップロード
    const [inputSlideFile, InputSlideFile] = useState(null);
    const [inputSlideName, InputSlideName] = useState("");
    // コンテンツアップロードテキスト
    const [textUploadSlide, ChangeTextUploadSlide] =
        useState("アップロードするファイルを選択（50MBまで）");

    // プロフェッショナル
    const [inputSlideProfessional, InputSlideProfessional] = useState(-1);

    // コンテンツ要約
    const [inputSlideDetail, InputSlideDetail] = useState("");

    // 資料アップロード
    const [alreadyUploadDocumentList, ChangeAlreadyUploadDocumentList] = useState<
        VideoExtraMaterial[]
    >([]);
    const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
    const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>([]);

    // タグ選択モーダル画面
    const [tagList, setTagList] = useState<string[]>([]);

    // グループ
    const [group, setGroup] = useState<Group[]>([]);

    // Chapter一覧の設定
    const [chapterList, setChapterList] = useState<Chapter[]>([]);

    // Tip一覧の設定
    const [tipList, setTipList] = useState<Tip[]>([]);

    // コンテンツタイトル入力
    const [isErrorTitleValidation, CheckTitleValidation] = useState(false);

    // コンテンツ要約入力
    const [isErrorDescriptionValidation, CheckDescriptionValidation] = useState(false);

    // キャンセルボタンを押下の場合、ダイアログボックス表示・非表示変数定義
    const [showDialogBox, setShowDialogBox] = useState(false);

    // コンテンツ編集モーダル表示用変数定義
    const [isOpenEditSlideModal, showOpenEditSlideModal] = useState(false);

    // ユーザデータAPIコール
    useEffect(() => {
        if (isOpenEditSlideModal) {
            dispatch(GetUserInfoList());
            dispatch(getTagList([]));
        }
    }, [dispatch, isOpenEditSlideModal]);

    const OpenEditSlideModal = () => {
        showOpenEditSlideModal(true);
        if (setIsEditing) {
            setIsEditing(true);
        }
    };

    //　コンテンツ編集モーダル表示・非表示
    const closeEditSlideModal = () => {
        // スライドビュー詳細URLから値取得
        const getPathName: string = location.pathname.substring(
            location.pathname.lastIndexOf("/") + 1
        );
        if (getPathName === "contents") {
            // コンテンツ情報リセット処理APIコール
            dispatch(ResetSlideInfo());
        }

        if (isSaved) {
            showOpenEditSlideModal(false);
            if (setIsEditing) {
                setIsEditing(false);
            }
            // コンテンツファイル
            InputSlideFile(null);
            // タイトル
            InputSlideName("");
            // プロフェッショナル
            InputSlideProfessional(-1);
            // 要約
            InputSlideDetail("");
            // 資料
            ChangeDocumentList([]);
            ChangeDocumentNameList([]);
            // タグ
            setTagList([]);
            // グループ
            setGroup([]);
            // Indexリスト
            setChapterList([]);
            // 補足リスト
            setTipList([]);
            // 添付資料
            ChangeAlreadyUploadDocumentList([]);
        } else {
            if (tempFile.keyName !== "") {
                setSlideTempFileCheckFlg(true);
            }
            setShowDialogBox(true);
        }
    };

    // ページ遷移かTempFileがあるか表示フラグ定義
    const [contentTempFileCheckFlg, setSlideTempFileCheckFlg] = useState(false);

    // tempFilePageCountが-1の場合のメッセージ表示フラグ
    const [isTempFilePageCountError, setIsTempFilePageCountError] = useInitFlag(false);

    const handleCloseInputError = () => {
        setIsTempFilePageCountError(false);
    };

    // SlideView画面から渡されたIDとStoreからのIDが一致しない場合、
    useEffect(() => {
        if (user && isOpenEditSlideModal) {
            if (slideId !== slide?.id) dispatch(GetSlideById(Number(user.id), slideId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slideId, isOpenEditSlideModal]);

    // GetTempPageCount APIコール
    useEffect(() => {
        let timerGetSlidePageCount: NodeJS.Timeout;
        let timerGetTempPageCount: NodeJS.Timeout;

        // slide.fileNameよりGetSlidePageCount取得
        if (slide !== undefined && slide.fileName !== "" && slideId === slide.id) {
            if (slidePageCount === 0) {
                timerGetSlidePageCount = setTimeout(() => {
                    dispatch(GetSlidePageCount(slideId, slide.fileName));
                }, 3000);
            }
        }

        // 編集画面で、コンテンツアップロードするとGetTempPageCount取得
        if (tempFile.keyName !== "" && isSuccessGetTempFilePageCount) {
            if (tempFilePageCount === 0) {
                timerGetTempPageCount = setTimeout(
                    () => dispatch(GetTempPageCount(tempFile.keyName)),
                    3000
                );
                timerGetTempPageCount = setTimeout(() => {
                    dispatch(GetTempPageCount(tempFile.keyName));
                }, 3000);
            } else if (tempFilePageCount === -1) {
                setIsTempFilePageCountError(true);
            }
        }

        // クリーンアップ
        return () => {
            clearTimeout(timerGetSlidePageCount);
            clearTimeout(timerGetTempPageCount);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slide, slideId, tempFile.keyName, isSuccessGetTempFilePageCount, visibleDetailInfoPage]);

    // 初期コンテンツ情報設定
    useEffect(() => {
        if (slide !== undefined && isOpenEditSlideModal) {
            ChangeTextUploadSlide(slide.fileName);
            InputSlideName(slide.title);
            InputSlideProfessional(slide.presenterId);
            InputSlideDetail(slide.description);
            ChangeAlreadyUploadDocumentList(slide.extraMaterials);
            setTagList(slide.tags);
            setGroup(slide.group ?? []);
            setChapterList(slide.chapter);
            setTipList(slide.tips);
        }
    }, [slide, isOpenEditSlideModal]);

    // 保存した後、Modalボックスを閉じる。
    useEffect(() => {
        if (isSaved) {
            closeEditSlideModal();
        }
        // eslint-disable-next-line
    }, [isSaved]);

    // ダイアログボックスのキャンセルボタンを押下の場合、ダイアログボックス表示・非表示
    const handleCloseDialog = () => {
        setShowDialogBox(false);
    };
    const handleCancel = () => {
        handleCloseDialog();
    };

    // handleConfirmイベントでページ遷移のダイアログボックスの非表示後、コンテンツ編集モーダル非表示フラグ
    const [closeEditModal, isCloseEditModal] = useState(false);
    const handleConfirm = () => {
        if (tempFile.keyName !== "") {
            // tempFileデータをクリアする
            dispatch(DeleteTempFile(tempFile.keyName));
        }
        if (user && slide) {
            dispatch(GetSlideById(Number(user.id), slide.id));
        }
        setIsSaved(true);
        handleCloseDialog();
        isCloseEditModal(true);
    };
    useEffect(() => {
        if (closeEditModal && !showDialogBox) {
            ShowDetailInfoPage(true);
            closeEditSlideModal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeEditModal, showDialogBox]);

    // コンテンツ削除確認モーダル表示制御
    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);
    // コンテンツ削除確認モーダル表示
    const OpenVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(true);
    };
    // コンテンツ削除確認モーダル非表示
    const CloseVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(false);
    };

    // 削除ボタンを押下の場合
    const handleDeleteSlideBtn = () => {
        OpenVerifyDeleteModal();
    };

    // コンテンツ削除モーダルの削除キャンセルボタン押下
    const handleCancelDeleteBtn = () => {
        CloseVerifyDeleteModal();
    };

    // コンテンツ削除モーダルの削除確認ボタン押下
    const handleConfirmDeleteBtn = () => {
        CloseVerifyDeleteModal();
        closeEditSlideModal();
        // 削除APIコール
        dispatch(DeleteSlide(slideId));
    };
    // コンテンツ削除後、一覧画面に戻る
    useEffect(() => {
        if (isSuccessDeleteSlide) {
            history.push("/contents");
            dispatch(ResetSlideInfo());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccessDeleteSlide]);

    // 詳細情報入力の無効制限
    const [showDetailInfoBtn, setShowDetailInfoBtn] = useState(false);
    useEffect(() => {
        if (tempFilePageCount < 1 || slidePageCount < 1) setShowDetailInfoBtn(true);
    }, [tempFilePageCount, slidePageCount]);

    // 編集ボタンの有無効制御
    const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
    useEffect(() => {
        if (
            !isSaved &&
            inputSlideName !== "" &&
            inputSlideDetail !== "" &&
            !isErrorTitleValidation &&
            !isErrorDescriptionValidation
        ) {
            ChangeReadyToSendFlag(false);
        } else {
            ChangeReadyToSendFlag(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSaved,
        inputSlideName,
        inputSlideDetail,
        isErrorTitleValidation,
        isErrorDescriptionValidation,
    ]);

    // コンテンツ編集ボタン押下
    const handleEditSlideBtn = () => {
        if (user && slide) {
            const defaultMaterialIdList: number[] = [];
            slide.extraMaterials?.map(function (row) {
                defaultMaterialIdList.push(row.id);
                return null;
            });

            const materialIdList: number[] = [];
            alreadyUploadDocumentList?.map(function (row) {
                materialIdList.push(row.id);
                return null;
            });
            const sendMaterialIdList: number[] = defaultMaterialIdList.filter(
                (i) => materialIdList.indexOf(i) === -1
            );
            if (tempFile.keyName) {
                dispatch(
                    EditSlide({
                        userId: user.id,
                        materialId: sendMaterialIdList,
                        documentFile: inputDocumentList,
                        documentName: inputDocumentNameList,
                        content: {
                            id: slide.id,
                            keyName: tempFile.keyName,
                            fileName: tempFile.fileName,
                            title: inputSlideName,
                            description: inputSlideDetail,
                            presenterId: inputSlideProfessional,
                            tags: GetTagIdFromTagName(tagList, tags),
                            group: group.map((item) => Number(item.id)),
                            chapter: chapterList,
                            tips: tipList,
                        },
                    })
                );
            } else {
                dispatch(
                    EditSlide({
                        userId: user.id,
                        //確認
                        materialId: sendMaterialIdList,
                        documentFile: inputDocumentList,
                        documentName: inputDocumentNameList,
                        content: {
                            id: slide.id,
                            title: inputSlideName,
                            fileName: tempFile.fileName,
                            description: inputSlideDetail,
                            presenterId: inputSlideProfessional,
                            tags: GetTagIdFromTagName(tagList, tags),
                            group: group.map((item) => Number(item.id)),
                            chapter: chapterList,
                            tips: tipList,
                        },
                    })
                );
            }
            // 更新後、フラグ設定
            setIsSaved(true);
        }
    };

    return (
        <>
            {/* AdminかEditor権限がある場合、編集ボタン表示 */}
            {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                <div className={styles.menuArea} onClick={OpenEditSlideModal}>
                    <Fab
                        variant="circular"
                        size="small"
                        onClick={OpenEditSlideModal}
                        className={classes.icon}
                    >
                        <EditIcon style={{ color: "var(--button-bg)" }} />
                    </Fab>
                </div>
            )}
            <Modal
                open={isOpenEditSlideModal}
                onClose={closeEditSlideModal}
                className={styles.editSlideModal}
            >
                <div className={styles.contentmodal}>
                    {IsDevice("desktop") && (
                        <IconButton onClick={() => showOpenEditSlideModal(false)}>
                            <ClearIcon
                                style={{
                                    color: "#808080",
                                    fontSize: "29px",
                                    top: "calc(2.5% - 13px)",
                                    right: "calc(1% - 0px)",
                                    position: "fixed",
                                }}
                            />
                        </IconButton>
                    )}
                    {!IsDevice("desktop") && (
                        <div
                            onClick={() => showOpenEditSlideModal(false)}
                            className={styles.closeButton}
                        >
                            <img
                                src={require("../../../../../src/assets/image/closeFilter.svg")}
                                alt="close"
                            />
                        </div>
                    )}
                    <div className={styles.titleText}>
                        <PuiTypography size={18}>スライドの編集</PuiTypography>
                    </div>
                    {visibleDetailInfoPage ? (
                        <>
                            {/* Slide詳細情報入力画面 */}
                            <SlideStockInfoDetail
                                setIsSaved={setIsSaved}
                                inputSlideFile={inputSlideFile}
                                InputSlideFile={InputSlideFile}
                                textUploadSlide={textUploadSlide}
                                ChangeTextUploadSlide={ChangeTextUploadSlide}
                                inputSlideName={inputSlideName}
                                InputSlideName={InputSlideName}
                                inputSlideProfessional={inputSlideProfessional}
                                InputSlideProfessional={InputSlideProfessional}
                                inputSlideDetail={inputSlideDetail}
                                InputSlideDetail={InputSlideDetail}
                                isErrorTitleValidation={isErrorTitleValidation}
                                CheckTitleValidation={CheckTitleValidation}
                                isErrorDescriptionValidation={isErrorDescriptionValidation}
                                CheckDescriptionValidation={CheckDescriptionValidation}
                                ChangeDocumentList={ChangeDocumentList}
                                inputDocumentList={inputDocumentList}
                                ChangeDocumentNameList={ChangeDocumentNameList}
                                inputDocumentNameList={inputDocumentNameList}
                                tagList={tagList}
                                setTagList={setTagList}
                                showDetailInfoBtn={showDetailInfoBtn}
                                handleDetailInfoBtn={handleDetailInfoBtn}
                                group={group}
                                setGroup={setGroup}
                                alreadyUploadDocumentList={alreadyUploadDocumentList}
                                ChangeAlreadyUploadDocumentList={ChangeAlreadyUploadDocumentList}
                                isEditModal={true}
                            />
                            <div>
                                <div className={styles.buttonGroup}>
                                    <Button
                                        type="submit"
                                        onClick={handleDeleteSlideBtn}
                                        style={{
                                            marginRight: "10px",
                                            color: "#9C9C9C",
                                            fontSize: "16px",
                                            fontFamily: "noto-sans-cjk-jp,sans-serif",
                                            border: "solid 2px #5D5D5D",
                                        }}
                                        className={styles.updateButton}
                                    >
                                        スライドを削除
                                    </Button>
                                    {isReadyToUpdate ? (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            disabled
                                            type="submit"
                                            color="secondary"
                                            className={styles.updateButton}
                                            style={{
                                                fontSize: "16px",
                                                color: "white",
                                                fontFamily: "noto-sans-cjk-jp,sans-serif",
                                                backgroundColor: "var(--studio-btn-bg)",
                                            }}
                                        >
                                            更新
                                        </Button>
                                    ) : (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            type="submit"
                                            onClick={handleEditSlideBtn}
                                            style={{
                                                fontSize: "16px",
                                                color: "white",
                                                fontFamily: "noto-sans-cjk-jp,sans-serif",
                                                backgroundColor: "var(--studio-btn-bg)",
                                            }}
                                            className={styles.updateButton}
                                        >
                                            更新
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* スライド表示・Index情報入力・Tips情報入力画面 */}
                            <div
                                className={styles.detailInfoDiv}
                                style={{ width: IsDevice("desktop") ? "1060px" : "" }}
                            >
                                <DetailInfo
                                    setIsSaved={setIsSaved}
                                    chapterLists={chapterList}
                                    setChapterList={setChapterList}
                                    tipLists={tipList}
                                    setTipList={setTipList}
                                    editFlg={true}
                                    isEditModal={true}
                                />
                            </div>
                            <div className={styles.completeBtn}>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    type="submit"
                                    onClick={handleCompleteBtn}
                                    style={{
                                        fontSize: "16px",
                                        color: "white",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        backgroundColor: "var(--studio-btn-bg)",
                                    }}
                                    className={styles.updateButton}
                                >
                                    完了
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {/* コンテンツ削除モーダル */}
            <Modal open={isOpenVerifyDeleteModal} onClose={CloseVerifyDeleteModal}>
                <div className={styles.verifyDeleteModal}>
                    <Button onClick={CloseVerifyDeleteModal} />
                    <ul className={styles.deleteModalUl}>
                        <li className={styles.deleteModalTitle}>対象のコンテンツを削除しますか</li>
                        <li className={styles.deleteModalBtns}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyCancelButton}
                                onClick={handleCancelDeleteBtn}
                                style={{
                                    marginRight: "10px",
                                    fontSize: "16px",
                                    color: "#9C9C9C",
                                    fontFamily: "noto-sans-cjk-jp,sans-serif",
                                    border: "solid 2px #5D5D5D",
                                }}
                            >
                                キャンセル
                            </Button>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyDeleteButton}
                                onClick={handleConfirmDeleteBtn}
                                style={{
                                    color: "white",
                                    backgroundColor: "var(--studio-btn-bg)",
                                    fontFamily: "noto-sans-cjk-jp,sans-serif",
                                    fontSize: "16px",
                                }}
                            >
                                削除
                            </Button>
                        </li>
                    </ul>
                </div>
            </Modal>

            {/* キャンセルボタンを押下の場合、ダイアログボックス表示 */}
            {/* 新規コンテンツアップロードした場合、tempFile.keyNameがあるかによってメッセージ表示・tempFile.keyName削除 */}
            <OnLeaveDialog
                openDialog={showDialogBox}
                dialogTitle={
                    contentTempFileCheckFlg
                        ? "コンテンツアップロード確認"
                        : "このページを移動しますか？"
                }
                dialogContent={
                    contentTempFileCheckFlg
                        ? "現在アップロードしているコンテンツファイルは失われます"
                        : "ページを移動すると、変更内容は失われます"
                }
                dialogActions={"ページ移動"}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />

            <PuiMessage
                open={isTempFilePageCountError}
                type="error"
                title={
                    "ファイルの解析に失敗しました。再度アップロードするか、別のファイルをアップロードしてください"
                }
                onClose={handleCloseInputError}
            />
        </>
    );
}
export default EditSlideStock;
